export const POPUPS = {
  // ── Shared offering popups ───────────────────────────────────────────────

  ONBOARDING: {
    TITLE: 'Add new Step',
    DESCRIPTION_LABEL: 'Step description',
    DESCRIPTION_HINT:
      'Enter the specific command or action the user must execute to access your offering.',
    URL_LABEL: 'Access URL (optional)',
    URL_HINT: 'Add a link to the access destination.',
  },

  AVAILABLE_VERSION: {
    TITLE: 'Add new Available Version',
    VERSION_LABEL: 'Version',
    VERSION_HINT: 'Enter the identifier for the specific release.',
    STATUS_LABEL: 'Status',
    STATUS_HINT: 'Select the status of this specific version.',
    COMPATIBILITY_LABEL: 'Compatibility',
    COMPATIBILITY_HINT:
      'Describe version compatibility, dependencies, or technical requirements.',
    RELEASE_DATE_LABEL: 'Release Date',
    RELEASE_DATE_HINT: 'Define the date this version was made available.',
    END_OF_LIFE_DATE_LABEL: 'End-of-life date (optional)',
    END_OF_LIFE_DATE_HINT:
      'Define the scheduled date for the version to be retired.',
    ADDITIONAL_INFORMATION_LABEL: 'Additional information (optional)',
    ADDITIONAL_INFORMATION_HINT:
      'Enter detailed notes or context regarding this version.',
  },

  SUPPORT_CHANNEL: {
    TITLE: 'Add new Support Channel',
    CHANNEL_TYPE_LABEL: 'Channel',
    CHANNEL_TYPE_HINT: 'Select the medium used for communication.',
    DESTINATION_LABEL: 'Destination',
    DESTINATION_HINT: 'Enter specific contact address, link, or number.',
    DESCRIPTION_LABEL: 'Channel description (optional)',
    DESCRIPTION_HINT:
      'Enter a brief context about the specific support channel/request (maximum 500 characters).',
    SERVICE_DESK_LABEL: 'Support instance name',
    SERVICE_DESK_HINT:
      'Enter the specific name for the support request in ServiceNow.',
  },

  SUPPORT_HOUR: {
    TITLE: 'Add new Support Hour',
    DAYS_LABEL: 'Support days',
    DAYS_HINT: 'Select the days of the week support is available.',
    START_TIME_LABEL: 'Operating hours start at',
    START_TIME_HINT: 'Select the start of the support window.',
    END_TIME_LABEL: 'Operating hours end at',
    END_TIME_HINT: 'Select the end of the support window.',
    TIMEZONE_LABEL: 'Timezone',
    TIMEZONE_HINT: 'Select the timezone governing the operating hours.',
    RESPONSE_TIME_LABEL: 'Expected response time',
    RESPONSE_TIME_HINT:
      'Define SLA or internal guideline for responding to inquiries.',
    APPLY_247: 'Apply 24/7 Support Hours',
  },

  ENVIRONMENT: {
    TITLE: 'Add new Environment & Service Level Agreement',
    NAME_LABEL: 'Environment',
    NAME_HINT: 'Select the specific deployment environment tier.',
    URL_LABEL: 'Environment URL (optional)',
    URL_HINT: 'Add a direct link to the environment.',
    SLA_LABEL: 'Service Level Agreement (SLA)',
    SLA_HINT:
      'Select the formal commitment level regarding availability for this specific environment.',
  },

  FEATURE: {
    TITLE: 'Add new Feature',
    NAME_LABEL: 'Feature name',
    NAME_HINT: 'Enter a short, descriptive title for the specific feature.',
    DESCRIPTION_LABEL: 'Feature description',
    DESCRIPTION_HINT: 'Enter a brief explanation of the feature.',
    BENEFIT_LABEL: 'Feature benefit',
    BENEFIT_HINT:
      'Enter the specific value or advantage provided to the user or stakeholder.',
  },

  USE_CASE: {
    TITLE: 'Add new Use Case',
    NAME_LABEL: 'Use case name',
    NAME_HINT: 'Enter a brief use case name.',
    DESCRIPTION_LABEL: 'Use case description',
    DESCRIPTION_HINT:
      'Enter a brief explanation of how the offering is used and who uses it.',
  },

  QUALIFICATION_DOCUMENTATION: {
    TITLE: 'Add new Qualification documentation',
    NAME_LABEL: 'Qualification document name',
    URL_LABEL: 'Qualification document URL',
  },

  HOSTING: {
    TITLE: 'Add new Hosting Information',
    NAME_LABEL: 'Hosting provider name',
    NAME_HINT: 'Enter the formal name of the hosting solution or provider.',
    TYPE_LABEL: 'Hosting type',
    TYPE_HINT:
      'Select the categorization of the hosting environment based on the service model and location.',
    MANAGED_LABEL: 'Hosting management',
    MANAGED_HINT: 'Select the responsibility for managing the environment.',
  },

  COMMUNITY: {
    TITLE: 'Add new Community',
    TITLE_LABEL: 'Community name',
    TITLE_HINT: 'Enter a brief name or title of the community group.',
    DESCRIPTION_LABEL: 'Community description',
    DESCRIPTION_HINT:
      'Enter a brief context about the specific support channel or request (maximum 500 characters).',
    URL_LABEL: 'Community URL',
    URL_HINT: 'Add a link to the community platform.',
  },

  AI_AGENT: {
    TITLE: 'Add new AI Agent',
    NAME_LABEL: 'AI Agent name',
    NAME_HINT:
      'Enter the formal name of your AI agent that is associated with the offering.',
    URL_LABEL: 'AI Agent URL',
    URL_HINT: 'Add the direct web link or endpoint to access the specific agent.',
  },

  ADDON: {
    TITLE: 'Add new Add-on',
    NAME_LABEL: 'Add-on name',
    NAME_HINT: 'Enter the official name for your add-on.',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_HINT: "Enter a brief explanation of the add-on's functionality.",
    COST_LABEL: 'Cost',
    COST_PLACEHOLDER: 'Select cost type',
    COST_HINT:
      'Indicate if there is an extra cost to use the add-on and who is financially responsible.',
    SUPPORT_LABEL: 'Support (optional)',
    SUPPORT_PLACEHOLDER: 'Enter support details',
    SUPPORT_HINT:
      'Indicate if the add-on is officially supported by Roche internal teams.',
    URL_LABEL: 'URL (optional)',
    URL_HINT: 'Enter the link to the add-on.',
  },

  CAPABILITY: {
    TITLE: 'Add new Major Capability',
    NAME_LABEL: 'Capability name',
    NAME_HINT: 'Enter a short, descriptive title for the specific capability.',
    DESCRIPTION_LABEL: 'Capability description',
    DESCRIPTION_HINT: "Enter a brief explanation of the capability's functionality.",
    BENEFIT_LABEL: 'Capability benefit',
    BENEFIT_HINT:
      'Enter the specific value or advantage provided to the user or stakeholder.',
  },

  SERVICE_AND_REQUEST: {
    TITLE: 'Add new Offering Request',
    ID_LABEL: 'Request ID',
    TYPE_LABEL: 'Request type',
    TYPE_HINT: 'Select the type of support or action being requested.',
    TITLE_LABEL: 'Request title',
    TITLE_HINT: 'Add a short user-facing name of the service or action.',
    DESCRIPTION_LABEL: 'Instructions for users (optional)',
    DESCRIPTION_HINT:
      'Enter a brief guidance on when a user should choose this specific option.',
    DESTINATION_LABEL: 'Destination URL',
    DESTINATION_HINT: 'Add direct link to the official request form.',
  },

  // ── Application-specific popup ───────────────────────────────────────────

  INSTALLATION: {
    TITLE: 'Add new Installation & Access Information',
    APPLICATION_TYPE_LABEL: 'Application type',
    APPLICATION_TYPE_HINT: 'Select a high-level software classification.',
    INSTRUCTION_LABEL: 'Instruction information description',
    INSTRUCTION_LABEL_HINT:
      'Enter any additional instructions or information needed.',
    LINK_LABEL: 'Access URL',
    LINK_HINT:
      'Add a direct URL to the installation package or related instructions.',
  },

  // ── Service-specific popup ───────────────────────────────────────────────

  RELATED_TECHNOLOGY: {
    TITLE: 'Add new Related Technology',
    NAME_LABEL: 'Related technology name',
    NAME_HINT:
      'Select the application, platform, or infrastructure used to provide the service.',
    DESCRIPTION_LABEL: 'Related technology description',
    DESCRIPTION_HINT:
      'Enter brief explanation of the related technology to the service and how it is used.',
  },

  // ── Knowledge-specific popups ────────────────────────────────────────────

  USER_INSTRUCTION: {
    TITLE: 'Add User instructions content',
    NAME_LABEL: 'Instruction title',
    DESCRIPTION_LABEL: 'Instruction description',
  },

  BEST_PRACTICE: {
    TITLE: 'Add Best practices content',
    TITLE_LABEL: 'Best practice title',
    DESCRIPTION_LABEL: 'Best practice description',
  },

  LEARNING_RESOURCE: {
    TITLE: 'Add Authoritative resources content',
    LINK_NAME_LABEL: 'Authoritative resource link name',
    LINK_LABEL: 'Authoritative resource link',
  },

  TECHNICAL_RESOURCE: {
    TITLE: 'Add Technical resources content',
    LINK_NAME_LABEL: 'Technical resource link name',
    LINK_LABEL: 'Technical resource link',
  },

  INTEGRATION: {
    TITLE: 'Add Integrations content',
    TITLE_LABEL: 'Integration title',
    DESCRIPTION_LABEL: 'Integration description',
    LINK_NAME_LABEL: 'Integration link name',
    LINK_LABEL: 'Integration link',
  },

  FAQ: {
    TITLE: 'Add FAQ content',
    QUESTION_LABEL: 'Question',
    ANSWER_LABEL: 'Answer',
  },

  ADDITIONAL_RESOURCE: {
    TITLE: 'Add Additional resources content',
    LINK_NAME_LABEL: 'Additional resource link name',
    LINK_LABEL: 'Additional resource link',
  },

  SUCCESS_STORY: {
    TITLE: 'Add Success stories content',
    TITLE_LABEL: 'Success story title',
    DESCRIPTION_LABEL: 'Success story description',
  },

  RELEASE_NOTE: {
    TITLE: 'Add Release notes content',
    NAME_LABEL: 'Release note name',
    HEADER_LABEL: 'Release note header',
    DESCRIPTION_LABEL: 'Release note description',
    LINK_LABEL: 'Release note link',
  },

  OFFERING_VALIDATION: {
    TITLE: 'Action required',
    DESCRIPTION:
      'You cannot save knowledge content until the offering is published. Please publish your offering before adding knowledge content',
  },

  UNPUBLISHED_CONFIRMATION: {
    TITLE: 'Unpublish Confirmation',
    DESCRIPTION: 'Are you sure you want to unpublish this content?',
    WARNING:
      'Unpublished content will not be visible to your users but will be stored in FOCUS',
  },

  UNSAVED_CONFIRMATION: {
    CONFIRMATION_MESSAGE:
      'You are closing the form. Unsaved changes will be lost. Would you like to continue?',
  },

  // ── Shared status popups ─────────────────────────────────────────────────

  SUCCESS: {
    OFFERING_PUBLISHED: {
      HEADLINE: 'Success',
      BODY: 'Your main offering content has been published!',
    },
    TITLE: 'Success',
    DESCRIPTION: 'Knowledge content has been successfully published',
  },

  ERROR: {
    TITLE: 'Invalid or missing fields',
    DESCRIPTION:
      'Offering can’t be published.\n\nPlease fill out the missing fields to publish:',
  },

  DRAFT_ERROR: {
    TITLE: 'Invalid or missing fields',
    DESCRIPTION:
      'Please provide Offering Name, Owner Email, and Deputy Email before saving as draft.',
  },

  DUPLICATE_NAME: {
    TITLE: 'Already exists',
    DUPLICATE_OFFERING_DESCRIPTION: 'An offering with this name already exists. Remove the duplicate offering to continue, or choose a different name',
    DUPLICATE_NAME_TITLE: 'Error - Duplicate Offering',
    KNOWLEDGE_DESCRIPTION: 'This knowledge content already exists.',
  },

  DELETE: {
    TITLE: 'Delete content',
    DESCRIPTION: 'Are you sure you want to delete this content?',
    WARNING: 'This action cannot be undone',
  },
};
